import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  headline: validator('presence', true),
  startDate: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
});

export const settings = {
  copyableOptions: {
    ignoreAttributes: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
    ],
  },
  variantProperties: [
    'city',
    'cmsLanguageId',
    'cmsState',
    'headline',
    'subHeadline',
    'text',
  ],
};

export default class CalendarEventModel extends Model.extend(Validations) {
  @attr('string') city;
  @attr('string') headline;
  @attr startDate;
  @attr('string') subHeadline;
  @attr('string') text;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('artist', { async: true, inverse: null }) artists;
  @belongsTo('category', { async: true, inverse: null }) categoryId;
  @belongsTo('category', { async: true, inverse: null }) calendarTypeId;
  @belongsTo('channel', { async: true, inverse: null }) ownedByChannel;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }
}
